import type { CoreExpression } from 'jsep';
import { ExpressionReturnType } from '../expressions/common';

export interface Expression {
  type: ExpressionReturnType;
  ast: CoreExpression;
}

export const expressionScopeRequestEvent = 'expression-scope-request';

export interface ExpressionScopeRequestPayload {
  identifiers: Record<string, ExpressionReturnType>;
}

export type ExpressionValidationResult =
  | { valid: true; type: ExpressionReturnType }
  | { valid: false; reason: string };
